module.exports = __webpack_public_path__ + "static/media/ico-checked-white.5c57b6be.svg";